import type { KnockMessage } from "../../../types/zod/knock";
import { MessageCard } from "./MessageCard";

interface Props {
	messages: KnockMessage[];
}

export function MessageList({ messages }: Props) {
	if (!messages.length) {
		return (
			<div className="py-8 text-muted-foreground text-center">
				No messages found
			</div>
		);
	}

	return (
		<div className="space-y-4">
			{messages.map((message) => (
				<MessageCard key={message.id} message={message} />
			))}
		</div>
	);
}
